<script>
import _ from 'lodash'
import { format } from 'date-fns'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  props: {
    extra: { type: Object, required: true },
  },
  data: () => ({
    available: _.range(0, 6),
  }),
  computed: {
    ...mapGetters('cart/extras', ['getItem']),
    ...mapState('cart', ['checkIn']),
    item() {
      return this.getItem(this.extra)
    },
    noOfItem: {
      get() {
        return this.item ? this.item.qty : 0
      },
      set(qty) {
        if (this.item) {
          this.updateExtra({ qty })
        } else {
          this.updateExtra({
            qty,
            date: this.checkIn,
            time: '14:00',
          })
        }
      },
    },
    extraDatePlaceholder() {
      let date = this.checkIn

      if (this.item) {
        date = this.item.date
      }

      return format(new Date(date), 'DD MMM YYYY')
    },
    extraTime: {
      get() {
        return this.item ? this.item.time : '14:00'
      },
      set(time) {
        this.updateExtra({ time })
      },
    },
    pickerOptions() {
      return {
        minDate: new Date(this.checkIn),
        onSelect: this.onSelectedDate,
      }
    },
  },
  methods: {
    ...mapActions('cart/extras', ['updateExtraCart']),
    onSelectedDate(startDate) {
      this.updateExtra({ date: startDate.format('YYYY-MM-DD') })
    },
    updateExtra({ qty, date, time }) {
      this.updateExtraCart({
        extra: this.extra,
        qty: qty !== undefined ? qty : this.item.qty,
        date: date || this.item.date,
        time: time || this.item.time,
      })
    },
  },
}
</script>

<template>
  <div>
    <div class="hidden md:flex my-3 text-sm font-medium">
      <div class="w-6/12">Description</div>
      <div class="w-4/12">Price</div>
      <div class="w-2/12">No. of item</div>
    </div>

    <div class="flex flex-wrap">
      <div class="w-full bg-white mb-3">
        <div class="flex flex-wrap border border-gray-400">
          <div class="w-full md:w-6/12 md:border-r border-gray-400">
            <div class="extra-description px-3 my-3">
              <p class="text-sm">
                {{ extra.description }}
              </p>
            </div>
          </div>
          <!-- extra description -->

          <div class="w-2/3 md:w-4/12 md:border-r border-gray-400">
            <div class="px-3 my-3">
              <div class="leading-none text-right">
                <div class="text-red-500">
                  <span class="text-xl mr-1">
                    {{ extra.rate.currency }}
                  </span>
                  <span class="font-medium text-2xl md:text-3xl">
                    {{ extra.rate.display | currency }}
                  </span>
                </div>
                <div class="text-sm leading-tight">
                  Price for 1
                  {{ extra.forEach }}
                </div>
                <div class="text-sm italic leading-tight">
                  {{ extra.rate.inclusiveFees ? 'Inclusive' : 'Exclusive' }} tax
                  and service
                </div>
              </div>
            </div>
          </div>
          <!-- extra price -->

          <div class="w-1/3 md:w-2/12">
            <div class="px-3 my-3">
              <div class="relative">
                <select v-model="noOfItem" class="input">
                  <option v-for="x in available" :key="x" :value="x">
                    {{ x }}
                  </option>
                </select>
                <div
                  class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2"
                >
                  <BaseIcon name="chevron-down" />
                </div>
              </div>
              <div v-if="noOfItem > 0" class="hidden md:block">
                <div class="mt-3">
                  <label :for="`date-${extra.id}`" class="label">Date</label>
                  <BaseDatepicker
                    :id="`date-${extra.id}`"
                    :value="extraDatePlaceholder"
                    :options="pickerOptions"
                  />
                </div>
                <div class="mt-3">
                  <label :for="`time-${extra.id}`" class="label">Time</label>
                  <BaseTimepicker
                    :id="`time-${extra.id}`"
                    v-model="extraTime"
                  />
                </div>
                <p class="mt-3 text-xs">
                  Preferred date and time is subject to availability.
                </p>
              </div>
            </div>
          </div>
          <!-- extra number of item -->

          <div v-if="noOfItem > 0" class="w-full block md:hidden">
            <div class="flex flex-wrap">
              <div class="w-1/2 px-3">
                <label :for="`date-mobile-${extra.id}`" class="label"
                  >Date</label
                >
                <BaseDatepicker
                  :id="`date-mobile-${extra.id}`"
                  :value="extraDatePlaceholder"
                  :options="pickerOptions"
                />
              </div>
              <div class="w-1/2 px-3">
                <label :for="`time-mobile-${extra.id}`" class="label"
                  >Time</label
                >
                <BaseTimepicker
                  :id="`time-mobile-${extra.id}`"
                  v-model="extraTime"
                />
              </div>
            </div>
            <p class="w-full px-3 my-3 text-xs">
              Preferred date and time is subject to availability.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- master extra details -->
</template>
